export default {
    inserted(el, binding, vnode, old) {
        const tableName = binding.value
        
        const hasAccess = !!vnode.context.$store.getters['user/access'](tableName)
        if (!hasAccess) {
            vnode.elm.parentElement.removeChild(vnode.elm)
        }
    }
}